module.exports = "/assets/site/images/first-section-bg.png?e8435583d9d9374f5494c53d53135c0b";